<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="from_div">
			<div class="receipt_div" :style="[divStyle]">
				<el-form ref="form" :model="form" :rules="rules" class="title_div" label-width="100px"
					label-position="left">
					<span class="title" v-if="type != -1">NO:{{form.bill_no}}</span>
					<div class="item">
						<span style="font-size: 24px;">发票申请单</span>
					</div>
					<el-divider class="lin" />
					<el-form-item label-width="0">
						<el-date-picker class="picker" :clearable='false' align="center" v-model="form.invoice_time"
							type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择时间" />
					</el-form-item>
					<el-form-item label="客户单位：" prop="consumer_id">
						<el-select class="select" v-model="form.consumer_id" clearable placeholder="客户列表"
							@change="consumerChange">
							<el-option v-for="item in consumerList" :key="item.consumer_id" :label="item.consumer_name"
								:value="item.consumer_id" />
						</el-select>
					</el-form-item>
					<el-form-item label="公司信息：" prop="company_name">
						<div class="row">
							<el-form-item prop="company_name">
								<el-input class="input" v-model="form.company_name" placeholder="公司名称" />
							</el-form-item>
							<el-form-item prop="company_name">
								<el-input class="input" v-model="form.company_tax_no" placeholder="公司税号" />
							</el-form-item>
						</div>
					</el-form-item>
					<el-form-item label="开票金额：" prop="invoice_amount">
						<el-input class="input" v-model="form.invoice_amount" placeholder="请输入内容" />
					</el-form-item>
					<el-form-item label="开票类型：" style="margin-bottom: 15px;">
						<el-select class="select" v-model="form.invoice_type" clearable placeholder="发票类型">
							<el-option v-for="item in invoiceList" :key="item.value" :label="item.label"
								:value="item.value" />
						</el-select>
					</el-form-item>
					<el-form-item label="开票要求：" style="margin-bottom: 0;">
						<el-checkbox-group v-model="form.invoice_need">
							<el-checkbox v-for="item in needeList" :label="item.lable"
								name="type">{{item.value}}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="时间要求：">
						<el-date-picker class="picker" style="width: 100%;" v-model="timeFrame" type="datetimerange"
							value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间"
							end-placeholder="结束时间" placeholder="请选择时间范围" />
					</el-form-item>
					<el-form-item label="关联合同：">
						<el-select class="select" v-model="form.contract_id" clearable placeholder="合同列表">
							<el-option v-for="item in contractList" :key="item.procurement_id"
								:label="item.procurement_name" :value="item.procurement_id" />
						</el-select>
					</el-form-item>
					<el-form-item label="说明备注：">
						<el-input class="input" style="width: 100%;" v-model="form.invoice_remark"
							placeholder="请输入内容" />
					</el-form-item>
					<!-- <el-form-item label="开票进度：">
						<div class="col">
							<el-checkbox-group v-model="form.type">
								<el-checkbox label="已开票" name="type" />
							</el-checkbox-group>
							<div class="row">
								<span>开票金额：</span>
								<el-input class="input" placeholder="请输入内容"></el-input>
								<span>发票编号：</span>
								<el-input class="input" placeholder="请输入内容"></el-input>
							</div>
						</div>
					</el-form-item> -->
					<!-- <el-form-item style="margin-bottom: 0px;">
						<span>制单：财务经理  胡凯 7876</span>
						<span style="margin: 100px;">审批：</span>
						<span>开票：财务经理  胡凯 7876</span>
					</el-form-item> -->
				</el-form>
			</div>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm('form')">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import {
		invoice,
		consumerLists,
		procurementLists
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
		props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				tip: '添加新的发票申请。',
				consumerList: [], //客户列表
				invoiceList: [{
					label: '普通发票',
					value: 1
				}, {
					label: '专用发票',
					value: 2
				}], //开票类型列表
				needeList: [{
					lable: 'goods',
					value: '附商品清单'
				}],
				contractList: [], //合同列表
				timeFrame: [], //时间范围
				form: {
					invoice_time: '', //时间
					consumer_id: '', //客户id
					company_name: '', //公司名称
					company_tax_no: '', //公司税号
					invoice_amount: '', //金额
					invoice_type: '', //类型:1=普通发票,2=专用发票
					invoice_need: [], //开票要求json,附商品清单goods
					invoice_start: '', //开始时间要求
					invoice_end: '', //截止时间要求
					contract_id: '', //合同id
					invoice_remark: '' //备注
				},
				rules: {
					consumer_id: [{
						required: true,
						message: '请选择客户单位',
						trigger: 'blur'
					}],
					company_name: [{
						required: true,
						message: '请输入公司名称',
						trigger: 'blur'
					}],
					company_tax_no: [{
						required: true,
						message: '请输入公司税号',
						trigger: 'blur'
					}],
					invoice_amount: [{
						required: true,
						message: '请输入开票金额',
						trigger: 'blur'
					}]
				}
			}
		},
		computed:{
			divStyle() {
				return {
					height: this.type != -1 ? '650px' : '610px'
				}
			}
		},
		mounted() {
			if (this.type != -1) {
				//编辑
				this.form.invoice_id = this.type;
				this.getInvoiceDetail();
			}
			this.getConsumerList();
		},
		methods: {
			
			//获取发票详情
			getInvoiceDetail(){
				invoice({invoice_id:this.form.invoice_id},3).then(res=>{
					if(res.code == 0){
						this.timeFrame = [res.data.invoice_start,res.data.invoice_end];
						this.consumerChange(res.data.consumer_id);
						for (var key in res.data) {
							if (this.form.hasOwnProperty(key)) {
								this.form[key] = res.data[key];
							}
						}
						this.form.bill_no = res.data.company_tax_no
					}else{
						this.$message.error(res.msg);
					}
				}).catch(err=>{})
			},

			//获取客户列表
			getConsumerList() {
				consumerLists({
					page: this.page,
					limit: this.limit
				}).then(res => {
					if (res.code == 0) {
						this.consumerList = res.data
					}
				}).catch(err => {})
			},

			//客户列表筛选
			consumerChange(consumer_id) {
				this.form.contract_id = ''
				var index = this.consumerList.findIndex(item => item.consumer_id == consumer_id)
				this.form.company_name = this.consumerList[index].consumer_company
				this.form.company_tax_no = this.consumerList[index].consumer_tax_no
				//获取合同列表
				procurementLists({
					consumer_id: consumer_id
				}, 3).then(res => {
					this.contractList = res.data
				})
			},
			
			//表单提交
			submitForm(from) {
				this.$refs[from].validate((valid) => {
					if (valid) {
						if (this.timeFrame.length > 0) {
							this.form.invoice_start = this.timeFrame[0]
							this.form.invoice_end = this.timeFrame[1]
						}
						//0：新增 2：编辑
						var type = this.type != -1 ? 2 : 0
						invoice({
							...this.form
						}, type).then(res => {
							if (res.code == 0) {
								this.$emit('close', 0)
							} else {
								this.$message.error(res.msg);
							}
						}).catch(err => {})
					} else {
						return false
					}
				})
			},

			close() {
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.title {
		font-size: 16px;
		text-shadow: 0 1px 0 #fff, 0 2px 0 #888,
			0 3px 0 #555, 0 4px 0 #666,
			0 5px 0 #333, 0 6px 2px rgba(0, 0, 0, .2),
			0 6px 1px rgba(0, 0, 0, .1), 0 0 5px rgba(0, 0, 0, .1),
			0 1px 3px rgba(0, 0, 0, .3), 0 3px 5px rgba(0, 0, 0, .2),
			0 5px 10px rgba(0, 0, 0, .25), 0 10px 10px rgba(0, 0, 0, .2),
			0 20px 20px rgba(0, 0, 0, .15);
	}

	.from_div {
		display: flex;
		justify-content: center;
		width: 100%;
		height: 600px;
		margin: 20px 20px;
		overflow: scroll;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.receipt_div {
		padding: 40px 30px;
		border: 1px solid #767676;
		border-radius: 10px;
	}

	.title_div {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.lin {
		display: block;
		height: 1px;
		width: auto;
		margin: 20px 120px;
	}

	.item {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}

	.input {
		width: 200px;
		margin-right: 30px;
	}

	.select {
		width: 170px;
	}

	/deep/.el-input__inner {
		border-left: none;
		border-right: none;
		border-top: none;
		border-radius: 0;
	}

	/deep/.el-radio__label {
		font-size: 17px;
	}

	/deep/.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {

		color: #EA0000;
		font-size: 12px;
		margin-right: 4px;
	}

	/deep/.el-radio__inner {
		width: 17px;
		height: 17px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}
</style>